import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Coffee, Clock, Bike, Eye, Droplet, Ruler } from 'lucide-react';

const PartnerCard = ({ title, icon: Icon, description, url }) => {
  const content = (
    <>
      <div className="w-14 h-14 rounded-lg bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] p-0.5 mb-3">
        <div className="w-full h-full bg-white rounded-lg flex items-center justify-center">
          <Icon className="w-7 h-7 text-[#662d91] group-hover:text-[#4897d2] transition-colors" />
        </div>
      </div>

      <h3 className="text-base font-bold text-center mb-1">{title}</h3>
      <p className="text-gray-600 text-center text-sm">{description}</p>
    </>
  );
  const className = "group flex flex-col items-center p-5 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105";

  if (url.startsWith('/')) {
    return (
      <Link to={url} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {content}
    </a>
  );
};

const PartnersSection = () => {
  const partners = [
    {
      title: "Заказ клубной формы",
      description: "HBR Sports",
      url: "https://hbrsports.co.il/Shop.aspx?ShopID=23#!/Leikin-Team/c/149801504",
      icon: ShoppingBag
    },
    {
      title: "Спортивное питание",
      description: "Sponser, SIS",
      url: "/shop",
      icon: Coffee
    },
    {
      title: "Спортивная обувь",
      description: "On Cloud, ING Sport",
      url: "https://ingsport.co.il/",
      icon: ShoppingBag
    },
    {
      title: "Спортивные часы",
      description: "Garmin, Tacx",
      url: "https://www.garmin.co.il/",
      icon: Clock
    },
    {
      title: "Велосипеды",
      description: "Wilier, Chapter 2",
      url: "https://www.lovetoride.co.il/",
      icon: Bike
    },
    {
      title: "Спортивные очки",
      description: "Oakley, Bolle",
      url: "https://www.taloptica.co.il/",
      icon: Eye
    },
    {
      title: "Экипировка для плавания",
      description: "Orca, Sepa",
      url: "https://www.sepa.co.il/",
      icon: Droplet
    },
    {
      title: "Велосипедный фитмент",
      description: "Amos Wolff Bike Master",
      url: "https://www.amoswolff.co.il/",
      icon: Ruler
    }
  ];

  return (
    <section id="partners" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-3">Наши партнеры</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Специальные предложения и скидки для участников команды
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="opacity-0 animate-fadeIn"
              style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'forwards' }}
            >
              <PartnerCard
                title={partner.title}
                description={partner.description}
                url={partner.url}
                icon={partner.icon}
              />
            </div>
          ))}
        </div>

        <div className="text-center mt-8 text-gray-600">
          <p>Перед совершением покупки обратитесь к тренеру для получения специальных условий и кодов скидок</p>
        </div>
      </div>
    </section>
  );
};


export default PartnersSection;
